// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mFTj","col":"styles_col__pv7kX","actions":"styles_actions__ri9Oa","conflict":"styles_conflict__3Gqsb"};